import { render, staticRenderFns } from "./popUp.vue?vue&type=template&id=fd1b74b2&scoped=true"
import script from "./popUp.vue?vue&type=script&lang=js"
export * from "./popUp.vue?vue&type=script&lang=js"
import style0 from "./popUp.vue?vue&type=style&index=0&id=fd1b74b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1b74b2",
  null
  
)

export default component.exports